export const vipNotificationsStyle = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  title: {
    whiteSpace: 'nowrap',
    marginBottom: '8px',
    textAlign: 'center',

    '@media (max-width: 639.98px)': {
      whiteSpace: 'normal',
    },
  },
  afterTitle: {
    whiteSpace: 'nowrap',
    marginBottom: '40px',
    textAlign: 'center',

    '@media (max-width: 639.98px)': {
      whiteSpace: 'normal',
    },
  },
  buttonWrapper: {
    display: 'flex',
    gap: '24px',
    marginTop: '48px',
    width: '571px',
  },
  input: {
    width: '379px',
    position: 'relative',

    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '571px',
    marginBottom: '24px',

    '@media (max-width: 768px)': {
      width: '100%',
      flexDirection: 'column',
      gap: '20px',

      '& > div': {
        width: '100%',
      },
    },
  },

  button: {
    whiteSpace: 'nowrap',
    width: 'fit-content',
  },
  phoneItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  phoneWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  trashIcon: {
    cursor: 'pointer',
  },
};
